import { css, type Theme } from "@emotion/react";

export const termsCheckbox = css`
  text-align: left;
`;

export const asterisk = (theme: Theme) => css`
  color: ${theme.danger.textBase};
`;
